angular
    .module('core')
    .directive('noIndexFollow', function (
        $rootScope : ng.IRootScopeService,
        broker
    ) {
        return {
            restrict: 'EA',
            replace: true,
            template: '<meta name="robots" content="noindex, follow" ng-if="nif.isNoIndexFollow" />',
            controllerAs: 'nif',
            controller: function($scope: ng.IScope) {
                $rootScope.$on('$routeChangeStart', () => this.isNoIndexFollow = false);
                broker.subscribe('noIndexFollow', 'ISNOINDEXFOLLOW',
                    e => this.isNoIndexFollow = e.data.isNoIndexFollow);

                $scope.$on('$destroy', () => {
                    broker.unsubscribe('noIndexFollow');
                });
            }
        };
    });
